export default __webpack_public_path__ + "static/media/cpath_logo_yellow.3946bc99.svg";